import {Component, OnInit} from '@angular/core';

import {AuthenticationService, BaseComponent} from 'iui-iconectiv-lib';
import {Usage} from "../shared/model/usage.model";
import {Account} from "../shared/model/account.model";
import {UsageDetailsService} from "./usage-details.service";
import {UsageSummary} from "../shared/model/usage-summary.model";
import {ActivatedRoute} from "@angular/router";
import {ServiceDeskService} from "../servicedesk/servicedesk.service";

@Component({
  selector: 'usage-details',
  templateUrl: './usage-details.component.html',
  styleUrls: ['./usage-details.component.scss']
})
export class UsageDetailsComponent extends BaseComponent implements OnInit {

  usageData: Usage[];
  usageHeaders: any[];

  summaryData: UsageSummary[];
  summaryHeaders: any[];

  usageLabel: string = '';

  account: Account;

  Object = Object;

  constructor(private route: ActivatedRoute,
              private authService: AuthenticationService,
              private usageService: UsageDetailsService,
              private serviceDeskService: ServiceDeskService) {
    super();

    this.usageHeaders = [
      {header: '', width: '5.5'},
      {header: 'Month', width: '18'},
      {header: 'Total Results', width: '13.1'},
      {header: 'TN Results', width: '10'},
      {header: 'TN File Results', width: '14'},
      {header: 'TN Range Results', width: '14.2'},
      {header: 'Code Results', width: '14.6'},
      {header: 'Number Pool Block Results', width: '25'},
    ];

    this.summaryHeaders = [
      {header: 'Month', width: '20'},
      {header: 'Total Queries', width: '15'},
      {header: 'Total Results', width: '15'},
      {header: 'Invoice #', width: '10'},
      {header: 'Invoice Amount', width: '15'},
      {header: 'Amount Due', width: '15'},
      {header: 'Invoice Status', width: '15'},
      {header: 'Date (Paid in Full)', width: '20'},
    ];
  }


  ngOnInit(): void {

    const authorizationToken = this.authService.getToken();

    var accountId = this.route.snapshot.params['accountId'];
    if (accountId === "admin") {
      this.usageLabel = "Usage Details"
      this.fetchAdminUsageData(authorizationToken);
    }
    else if (accountId) {
      this.usageLabel = "Usage Details for Account " + accountId;
      this.fetchAccountUsageData(authorizationToken, accountId);
      this.fetchAccountInfo(authorizationToken, accountId);
    }


    this.usageService.getMockUsageSummary(authorizationToken).subscribe(
      res => {
        if (res['status'] === 'fail') {
          this.summaryData = null;

          // prepare error message
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.displayErrorMessage(errorMessage);
        } else {

          // this.summaryData = res['usagesummary'];
          // if (this.summaryData.length === 0) {
          //   this.summaryData = null;
          // }
        }

      },
      error => {
        this.processHttpError(error);
      }
    );
  }

  fetchAccountUsageData(authorizationToken: string, accountId: string) {
    this.usageService.getAllUsage(authorizationToken, accountId).subscribe(
      res => {
        if (res['status'] === 'fail') {
          this.usageData = null;

          // prepare error message
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.displayErrorMessage(errorMessage);
        } else {

          this.usageData = res['usage'];
          if (this.usageData.length === 0) {
            this.usageData = null;
          }
        }

      },
      error => {
        this.processHttpError(error);
      }
    );

  }

  fetchAdminUsageData(authorizationToken: string) {
    this.usageService.getAdminUsage(authorizationToken).subscribe(
      res => {
        if (res['status'] === 'fail') {
          this.usageData = null;

          // prepare error message
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.displayErrorMessage(errorMessage);
        } else {

          this.usageData = res['usage'];
          if (this.usageData.length === 0) {
            this.usageData = null;
          }
        }

      },
      error => {
        this.processHttpError(error);
      }
    );

  }

  fetchAccountInfo(authorizationToken: string, accountId: string) {
    this.serviceDeskService.getAccountList(authorizationToken).subscribe(
      res => {
        this.log.debug(`data=${JSON.stringify(res).substr(0, 1000)}`);
        this.log.debug(`message=${JSON.stringify(res['messages'])}`);

        if (res['status'] === 'fail') {
          accounts = null;

          // prepare error message
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.displayErrorMessage(errorMessage);
        } else {

          var accounts = res['Accounts'];
          if (accounts.length === 0) {
            accounts = null;
          }
          else {
            this.account = accounts.find(a => a.accountId.toString() == accountId)
          }
        }

      },
      error => {
        this.processHttpError(error);
      }
    );

  }

}
